<template>
  <div>
    <ul class="newslist">
      <router-link :to="'/detail/' + item.id" tag="li" v-for="(item,index) in page_arrs" :key="index" class="margin-bottom-20">
        <div class="row">
          <div class="col-md-3">
            <img :src="item.imgUrl" class="newsimg" />
          </div>
          <div class="col-md-9">
            <div class="title">{{item.title}}</div>
           <!-- <div class="author">Post by: {{item.author}}</div>-->
            <div class="desc" v-html="item.dec"></div>
            <div class="date"><span class="margin-right-10">{{item.date}}</span><span>{{item.hits}}</span></div>
          </div>
        </div>
      </router-link>
    </ul>
    <div class="text-center margin-bottom-20">
    <div class="page">
      <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit" @click="primaryPage" >首页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="prePage" :class="{'active':activenum === 1}">上页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="nextPage" :class="{'active':activenum === 2}">下页</button>
      <button class="btn btn-default margin-right-10" type="submit" @click="lastPage" :class="{'active':activenum === 3}">尾页</button>
      <button class="btn btn-default" type="submit" style="background: none">{{current_page}}/{{Math.ceil(arrs.length/pagesize)}}</button>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'MajorList',
  props: {
    arrs: Array
  },
  data: function () {
    return {
      currentPage: 1, // 当前页号
      activenum: 0, // 每页大小
      pagesize: 5
    }
  },
  computed: {
    page_arrs () {
      let {currentPage, pagesize} = this
      return this.arrs.slice((currentPage - 1) * pagesize, currentPage * pagesize)
    },
    current_page () {
      return this.currentPage
    }
  },
  methods: {
    primaryPage () {
      this.currentPage = 1
      this.activenum = 0
    },
    prePage () {
      if (this.currentPage === 1) {
        this.activenum = 1
        return
      }
      this.currentPage = this.currentPage - 1
      this.activenum = 1
    },
    nextPage () {
      if (this.currentPage === Math.ceil(this.arrs.length / this.pagesize)) {
        return
      }
      this.currentPage = this.currentPage + 1
      this.activenum = 2
    },
    lastPage () {
      this.currentPage = Math.ceil(this.arrs.length / this.pagesize)
      this.activenum = 3
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .newslist{
    li{
      height:190px;
      cursor:pointer;
      overflow hidden;
      border-bottom:1px solid $borderColor
      padding-bottom:20px;
      .newsimg{
        max-width:100%;
      }
      .title{
        font-size:18px;
        font-weight:bold;
        margin-bottom:10px;
        ellipsis()
      }
      .author{
        font-size :14px;
        color:#b7b7b7;
        margin-bottom:20px;
      }
      .desc{
        margin-bottom:10px;
        line-height:24px;
        color:#666;
        font-size:15px;
      }
      .date{
        color:#b7b7b7;
      }
    }
    .page{
      text-align center;
      margin-bottom:20px;
    }
  }
  .page >>> .btn{
    background:#eaeaea;
    &.active{
      background:$bgColor;
      color:#fff;
      border:none
    }
    .btn:focus,.page >>>.btn.focus {
       outline: 0;
      -webkit-box-shadow:  none;
       box-shadow: none
    }
  }
  .btn:focus, .btn.focus {
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .desc{
    line-height:24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/major/components/MajorList.vue